// 土耳其语
export const GUIDES = [
  { name: 'guide-overview', title: 'İşlevlere Genel Bakış', groupIndex: 0 },
  { name: 'guide-account', title: 'Hesap Hakkında', groupIndex: 0 },
  { name: 'guide-vehicle', title: 'Araç hakkında', groupIndex: 0 },
  { name: 'guide-meterSetting', title: 'Gösterge tablosu nasıl kurulur', groupIndex: 1 },
  { name: 'guide-vehicleSetting', title: 'Motosiklet nasıl kurulur', groupIndex: 1 },
  { name: 'guide-findNavigation', title: 'Motosiklet bulmak için nasıl gezinilir', groupIndex: 2 },
  { name: 'guide-vehicleNnavigation', title: 'Navigasyon nasıl kullanılır', groupIndex: 2 },
  { name: 'guide-cyclingRecord', title: 'Ride Geçmişi Hakkında', groupIndex: 3 },
  { name: 'guide-vehicleExperience', title: 'Kendi kendine araç muayenesi nasıl yapılır', groupIndex: 3 },
  { name: 'guide-useSetting', title: 'APP genel ayarları nasıl yapılır?', groupIndex: 3 },
  { name: 'guide-notice', title: 'Mesaj bildirimi nasıl görüntülenir ve ayarlanır?', groupIndex: 3 },
  { name: 'guide-about', title: 'APP hakkında', groupIndex: 4 },
];

// 息屏引导列表
export const REST_SCREENS = [
  { icon: 'vivo', name: 'vivo', title: 'VIVO' },
  { icon: 'mi', name: 'mi', title: 'MI' },
  { icon: 'huawei', name: 'huawei', title: 'HUAWEI' },
  { icon: 'honor', name: 'honor', title: 'HONOR' },
];

export const FEEDBACK_STATES = {
  0: 'Askıda olması',
  1: 'Cevap yok',
  2: 'Cevap verildi',
  3: 'iletişimde',
  4: 'karşı önlemler',
  5: 'çözüldü',
};

export const FEEDBACK_TYPES = {
  1: 'Geri bildirim',
  2: 'Yanıt',
};

export default {
  GUIDES,
  REST_SCREENS,
  FEEDBACK_STATES,
  FEEDBACK_TYPES,
};
